import React from 'react';
import { Typography, TypographyTagVariants } from '@components/atoms/Typography';
import { Space } from '@components/atoms/Space';
import { useTranslation } from 'react-i18next';
import { Container } from '@components/atoms/Container';
import styles from './WelcomeDriver.module.css';

export interface WelcomeDriverProps {
    name: string;
}

export const WelcomeDriver: React.FC<WelcomeDriverProps> = ({ name }) => {
    const { t } = useTranslation();

    const translations = {
        hello: t('welcome.hello'),
        welcome: t('welcome.welcome'),
        account: t('welcome.account'),
        validation: t('welcome.validation'),
        thanks: t('welcome.thanks'),
        hug: t('welcome.hug'),
    };

    return (
        <Container classes={styles.containerBackground}>
            <Space spaceBreakpoints={{ xs: { space: 30 } }} />
            <Typography fontWeight="800" fontSize="40" color="primary" align="center">
                {t('common.project')}
            </Typography>
            <Space spaceBreakpoints={{ xs: { space: 30 } }} />
            <div className={`${styles.cardBackground}`}>
                <Typography fontSize="16">{`${translations.hello} ${name}!`}</Typography>
                <Space spaceBreakpoints={{ xs: { space: 30 } }} />
                <Typography>{translations.welcome}</Typography>
                <Typography fontSize="16">
                    <>
                        {`${translations.account} `}
                        <Typography fontWeight="800" tagVariant={TypographyTagVariants.span}>
                            {translations.validation}
                        </Typography>
                    </>
                </Typography>
                <Space spaceBreakpoints={{ xs: { space: 30 } }} />
                <Typography fontSize="16">{translations.thanks}</Typography>
                <Space spaceBreakpoints={{ xs: { space: 30 } }} />
                <Typography fontSize="16">{translations.hug}</Typography>
            </div>
        </Container>
    );
};
